import { Typography, Row, Col } from "antd";
import { WarningOutlined } from "@ant-design/icons";

import "./index.css";

const LoadErrorText = ({ icon, message }) => (
  <Row justify="center" className="load-error-row">
    <Col>
      {icon ? (
        <WarningOutlined color="red" size={20} />
      ) : (
        <Typography.Text type="danger">{message}</Typography.Text>
      )}
    </Col>
  </Row>
);

export default LoadErrorText;
